import React from "react";
import { Radar, Brain, Compass } from "lucide-react";
import { useI18n } from "@/i18n";

const STEPS = [
  { n: 1, icon: Radar },
  { n: 2, icon: Brain },
  { n: 3, icon: Compass },
];

export function HowItWorks({ compact = false }) {
  const { t } = useI18n();
  return (
    <section data-testid="how-it-works" className={compact ? "" : "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"}>
      {!compact && <h2 className="font-display font-bold text-lg sm:text-xl tracking-tight mb-5">{t("how.title")}</h2>}
      <ol className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {STEPS.map(({ n, icon: Icon }) => (
          <li key={n} data-testid={`how-step-${n}`} className="relative bg-white border border-slate-200/80 rounded-xl p-5 overflow-hidden group hover:border-violet-300 transition-colors">
            <span className="absolute -top-3 end-3 font-display font-extrabold text-6xl text-violet-100 select-none">{n}</span>
            <span className="relative inline-flex w-9 h-9 items-center justify-center rounded-lg bg-violet-600 text-white mb-3 group-hover:scale-105 transition-transform">
              <Icon size={18} />
            </span>
            <h3 className="relative font-display font-bold text-slate-900">{n}. {t(`how.${n}.title`)}</h3>
            <p className="relative mt-1.5 text-sm text-slate-600 leading-relaxed">{t(`how.${n}.desc`)}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
